import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'crm-start',
  templateUrl: './crm-start.component.html',
  styleUrls: ['./crm-start.component.scss']
})
export class CrmStartComponent implements OnInit {
  constructor() {}

  ngOnInit() {}

  openCRM() {
    let params = `scrollbars=yes,resizable=no,status=no,location=no,toolbar=no,menubar=no,
width=1000,height=900,left=400,top=100`;

    open('/crm', 'CRM', params);
  }
}
